import { render, staticRenderFns } from "./MoveUserMachineGroup.vue?vue&type=template&id=12a87c88&"
import script from "./MoveUserMachineGroup.vue?vue&type=script&lang=js&"
export * from "./MoveUserMachineGroup.vue?vue&type=script&lang=js&"
import style0 from "./MoveUserMachineGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports